import AddTwoTone from "@mui/icons-material/AddTwoTone";
import Close from "@mui/icons-material/Close";
import {
  alpha,
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  IconButton,
  Stack,
  styled,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
import { http } from "../../../api/http";
import { Loader } from "../../../components/loader";

const CardAddAction = styled(Card)(
  ({ theme }) => `
        border: ${theme.palette.common.black} dashed 1px;
        height: 100%;
        color: ${theme.palette.primary.main};
        transition: ${theme.transitions.create(["all"])};
        box-shadow: none; 
        padding: ${theme.spacing(2)};
          height: 100%;
          justify-content: center;
          align-items: center;
          display: flex;
          cursor: pointer;
          
          .MuiTouchRipple-root {
            opacity: .2;
          }
          
          &:hover {
            border-color: ${theme.palette.primary.main};
            background-opacity: .2;
            background: ${alpha(theme.palette.primary.main, 0.1)};
          }

          & > * {
          cursor: pointer;
          }
`
);

const AvatarAddWrapper = styled(Avatar)(
  ({ theme }) => `
        background: ${theme.palette.common.black[5]};
        color: ${theme.palette.primary.main};
        width: ${theme.spacing(8)};
        height: ${theme.spacing(8)};

`
);

const FileUpload = ({
  url,
  onChange,
  accept = "*",
  onClick,
  onSuccess = () => {},
  type,
  subtype,
  questionBankId,
}: {
  url: string;
  onChange: (file: File) => void;
  accept?: string;
  onClick?: boolean;
  onSuccess?: () => void;
  type?: any;
  subtype?: any;
  questionBankId?: any;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [state, setState] = useState<any | null>(null);
  const [fileName, setFileName] = useState("");
  const theme = useTheme();

  const handleUpload = (e: any) => {
    if (e.target.files[0]) {
      setFileName(e.target.files[0]?.name);
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("type", type);
      formData.append("subType", subtype);
      formData.append("questionBankId", questionBankId);
      setState(formData);

      if (!onClick) {
        setLoading(true);
        axios
          .post(url, formData)
          .then((res: any) => {
            onChange(res.data);
            setLoading(false);
          })
          .catch((err: any) => {
            setLoading(false);
            toast.error(err.response.data.message);
            console.log(err);
          });
      }
    }
  };

  const submit = async () => {
    setLoading(true);
    try {
      const res = await http.post(url, state);
      onChange(res.data);
      setState(null);
      setFileName("");
      onSuccess();
      setLoading(false);
      toast.success("Questions imported successfully");
    } catch (err) {
      setLoading(false);
      console.log(err);
    }
  };

  return (
    <>
      {!fileName ? (
        <label htmlFor="audio-upload">
          <CardAddAction>
            <input
              onChange={handleUpload}
              type="file"
              accept={accept}
              name="audio-upload"
              id="audio-upload"
              hidden
            />
            <AvatarAddWrapper>
              {!loading ? (
                <Tooltip arrow title={"Click to add image"} placement="right">
                  <AddTwoTone fontSize="large" />
                </Tooltip>
              ) : (
                <CircularProgress />
              )}
            </AvatarAddWrapper>
          </CardAddAction>
        </label>
      ) : (
        <Box>
          {onClick && (
            <Stack gap={2}>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  border: `1px solid ${theme.palette.primary.light}`,
                  borderRadius: "0.5rem",
                  p: 1,
                  px: 2,
                }}
              >
                <Typography variant="h5">{fileName}</Typography>
                <IconButton
                  color="error"
                  size="small"
                  onClick={() => {
                    setState(null);
                    setFileName("");
                  }}
                >
                  <Close />
                </IconButton>
              </Stack>
              <Box>
                <Button
                  disabled={loading}
                  endIcon={loading && <Loader />}
                  variant="contained"
                  onClick={submit}
                >
                  Submit
                </Button>
              </Box>
            </Stack>
          )}
        </Box>
      )}
    </>
  );
};

export default FileUpload;
